<template>
  <div class="edit-video-box">
    <div>
      <!-- 操作栏 -->
      <div class="action-bar">
        <el-form ref="form" :model="roleInfo" label-width="100px" :rules="rules">
          <el-form-item label="角色名" prop="role">
            <div>
               <el-input v-model="roleInfo.role" size="small" placeholder="请输入角色名"></el-input>
            </div>
             <el-button type="warning" size="small" @click="set('all')">全选权限</el-button>
   <el-button type="primary" size="small" @click="handleClose()">返回</el-button>
            <div class="dialog-footer">
              <el-button type="success" size="small" :loading="flag" @click="submitForm()">确定保存</el-button>
            </div>
          </el-form-item>
          <el-col :span="12">
            <el-form-item label="权限">
              <el-tree :data="permessiList" :props="defaultProps" show-checkbox default-expand-all node-key="title" ref="tree" highlight-current></el-tree>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="功能">
              <el-tree :data="itemList" :props="defaultProps" show-checkbox default-expand-all node-key="name" ref="treeItem" highlight-current></el-tree>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/api'
import permessiList from '@/router/permissionRouter'
import local from '@/utils/localStroage'
import _ from 'lodash'

export default {
  props: {
    // 父组件传递的参数
    type: String,
    roleInfo: {
      status: false,
      name: '',
      id: '',
      authJson: [],
      actJson: '',
    },
  },
  data() {
    return {
      flag: false,
      permessiList: [],
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      itemList: [
        {
          name: 'homePage',
          title: '首页',
          children: [
            { name: 'isTodayStatistics', title: '今日数据统计' },
            { name: 'isTotalStatistics', title: '数据总汇统计' },
            { name: 'isTrafficChart', title: '访问量走势图' },
            { name: 'isRegisteredChart', title: '注册量走势图' },
          ],
        },
        {
          name: 'agentDistrictProvider',
          title: '商区管理',
          children: [
            {
              name: 'districtProvider',
              title: '代理列表',
              children: [
                {
                  name: 'statDialy',
                  title: '每日统计',
                  children: [
                    {
                      name: 'isRealData1',
                      title: '显示真实数据',
                    },
                  ],
                },
              ],
            },
            {
              name: 'dayTable',
              title: '每日报表',
              children: [
                {
                  name: 'isRealData2',
                  title: '显示真实数据',
                },
                {
                  name: 'isExport1',
                  title: '导出真实数据',
                },
              ],
            },
            {
              name: 'monthTable',
              title: '每月报表',
              children: [
                {
                  name: 'isRealData3',
                  title: '显示真实数据',
                },
                {
                  name: 'isExport2',
                  title: '导出真实数据',
                },
              ],
            },
          ],
        },
      ],
      rules: {
        role: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.permessiList = _.cloneDeep(permessiList)
  },
  methods: {
    /****************************权限列表数据*****************************/
    // 设置树组件的默认选择项
    set(perm) {
      let data
      if (perm === 'all') {
        // 全选
        data = this.generateKey(this.permessiList)
      } else {
        // 勾选已有权限
        data = this.generateKey(perm)
      }
      if (data.length === 0) return false
      this.$refs.tree.setCheckedNodes(data)
    },
    //功能
    treeItemAuth() {
      let treeItem = this.$refs.treeItem
      return {
        checked: treeItem.getCheckedNodes(),
        halfChecked: treeItem.getHalfCheckedKeys(),
      }
    },
    // 将获取的key值转换成数据所需要的格式
    generateTree(routes, data, checkedKeys) {
      const res = []
      for (let i = 0; i < routes.length; i++) {
        if (routes[i].children) {
          routes[i].children = this.generateTree(routes[i].children, routes[i].title, checkedKeys)
        }
        if (
          (routes[i].title && checkedKeys.includes(routes[i].title)) ||
          (routes[i].children && routes[i].children.length >= 1)
        ) {
          let item = routes[i]
          if (item.hasOwnProperty('component')) {
            delete item.component
          }
          res.push(item)
        }
      }
      return res
    },
    // 将数据转换成key值
    generateKey(data) {
      if (!data) return []
      const res = []
      for (const item of data) {
        if (item.children) {
          item.children = this.generateKey(item.children)
        }
        if (item.children && item.children.length > 0) {
          for (const i of item.children) {
            res.push(i)
          }
        } else {
          res.push(item)
        }
      }
      return res
    },
    // 表单验证提交
    submitForm() {
      this.flag = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.type === 'add') {
            this.addRole()
          } else {
            this.editRole()
          }
        } else {
          return false
        }
      })
    },
    // 添加角色
    addRole() {
      // 获取权限列表
      let keys = this.$refs.tree.getCheckedKeys()
      let data = this.permessiList.map((item) => Object.assign({}, item))
      let role = this.generateTree(data, '/', keys)
      let params = {
        authjson: JSON.stringify(role),
        role: this.roleInfo.role,
        actJson: JSON.stringify(this.treeItemAuth()),
      }
      API.addAuthor(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '添加成功',
              type: 'success',
            })
            this.$emit('handlerRoleList')
          } else if (res.code === 9200) {
            this.$message.error('新增角色号低于当前最新角色')
          } else {
            this.$message.error('添加失败')
          }
          this.handleClose()
          this.flag = false
        })
        .catch(() => {
          this.handleClose()
          this.flag = false
        })
    },
    // 编辑角色
    editRole() {
      // 获取权限列表
      let keys = this.$refs.tree.getCheckedKeys()
      let data = this.permessiList.map((item) => Object.assign({}, item))
      data = [...data]
      let role = this.generateTree(data, '/', keys)
      let params = {
        authjson: JSON.stringify(role),
        authID: this.roleInfo.id,
        role: this.roleInfo.role,
        actJson: JSON.stringify(this.treeItemAuth()),
      }
      // eslint-disable-next-line no-console
      API.updateAuthor(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '修改角色权限成功',
              type: 'success',
            })
            let userInfo = local.get('userInfo')
            if (userInfo.admin.role === this.roleInfo.role) {
              local.set('role', role)
              this.$store.dispatch('refreshRouter')
              this.$store.dispatch('removeAllTag')
              this.$store.dispatch('actJson')
              this.$store.dispatch('setRouterActive', '/welcome')
              this.$router.push({ path: '/welcome' })
            }
            this.$emit('handlerRoleList')
            this.handleClose()
          }
          this.flag = false
        })
        .catch(() => {
          this.handleClose()
          this.flag = false
        })
    },
    // 关闭弹窗
    handleClose() {
      this.$refs.tree.setCheckedNodes([])
      // 回调父组件的关闭函数
      this.$emit('handleClose')
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open() {
      // 默认设置权限树已有的权限
      let auth = this.roleInfo.authjson ? JSON.parse(this.roleInfo.authjson) : []
      this.set(auth)
      let actJson = this.roleInfo.actJson ? JSON.parse(this.roleInfo.actJson) : []
      if(actJson.checked){
        this.$refs.treeItem.setCheckedNodes(actJson.checked)
      }
      // this.set(actJson.checked);
      // console.log("弹窗打开时", permessiList)
    },
  },
}
</script>
<style  scoped>
.el-tree-node.is-expanded > .el-tree-node__children {
  display: flex;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  position: relative;
  top: -40px;
}
</style>
